<div class="header">
  <!-- Router link here is default ["/"] -->
  <spb-logo routerLink="['/home']" title="Certifikat"></spb-logo>
  <div [style.flex-grow]="1"></div>

  @if (configService.currentUser()) {
    <spb-toggle-button/>
    @if (configService.currentUser()!.name) {
      <span>{{ configService.currentUser()!.name }}</span>
      <button
        [style.padding-right.px]="40"
        [matMenuTriggerFor]="menu" mat-icon-button>
        <mat-icon>menu</mat-icon>
      </button>
    }
  }
</div>

<!-- Add other fancy navigations here -->
<mat-menu #menu="matMenu">
  <button (click)="configService.reset()" mat-menu-item>Logga ut</button>
</mat-menu>